import React, { useEffect } from 'react';
import {
  Box,
  HStack,
  VStack,
  useColorModeValue,
  Link,
  Text,
  Button,
  Center,
  ChakraProvider,
  Spinner
} from '@chakra-ui/react';
import {
  ArrowForwardIcon
} from '@chakra-ui/icons';
import { useState } from 'react';
import 'react-quill/dist/quill.snow.css';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import moment from 'moment';


import './Post.css';
import {PostItem, CommentItem, ReplyItem} from "../../interfaces"
import AppShell from '../../components/AppShell';
import QuillEditor from '../../components/QuillEditor';
import { calculateSize, calculateTitleSize } from '../../helpers';


const Post = () => {
  // !!! B E G I N   A U T H   B L O C K !!! //
  const [isAuthed, setIsAuthed] = useState(false);
  const cookies = new Cookies(null, { path: '/' });
  
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }

  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);

  useEffect(() => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }

    fetch(location.protocol + '//' + location.host + '/authenticated/' + token)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setIsAuthed(data["isAuthed"]);
      });
    }, [])
    // !!! E N D   A U T H   B L O C K !!! //

  return (
    <ChakraProvider>
      <AppShell isAuthed={isAuthed}>
        <PostPage width={width} isAuthed={isAuthed}/>
      </AppShell>
    </ChakraProvider>
  )
}

interface PostPageProps {
  width: number
  isAuthed: boolean
}

const PostPage = ({isAuthed, width}: PostPageProps) => {
    const {postId = "NA"} = useParams();
    const [isLoading, setIsLoading] = useState(true)
    const [postItem, setPostItem] = useState({} as PostItem);
    const [isCommentWriterOpen, setIsCommentWriterOpen] = useState(useLocation().state.commentWriter ? useLocation().state.commentWriter : false);

    const navigate = useNavigate(); 

    useEffect(() => {
      fetch(location.protocol + '//' + location.host + '/get/post/' + postId, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          setPostItem(data);
        });
    }, []);

    useEffect(() => {
      if (postItem.contents !== undefined) {
        setIsLoading(false)
      }
    }, [postItem])

    useEffect(() => {
    }, [isLoading])

    const submitComment = (_: string, value: string) => {
      fetch(location.protocol + '//' + location.host + '/create/comment', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "postId": postId,
          "contents": value,
        })
      })
      .then((res) => {
        if (res.status === 200) {
          alert("Comment successfully submitted!")
          navigate(".", {
            replace: true,
            state: {
              commentWriter: false,
              postEditor: false,
            }
          });
          window.location.reload();
        } else {
          alert("Failed to submit comment.")
        }
      })
        setIsCommentWriterOpen(!isCommentWriterOpen)
    }

    const renderCommentWriter = () => {
      if (isCommentWriterOpen) {
        return (
          <QuillEditor onSubmit={submitComment} topText={"New Comment"} topTextSize="medium" hasTitleField={false} p='4' m='0' width={width}/>
        )
      }

      return null
    }

    return (
      <>
        {isLoading &&
          <Center>
            <VStack>
              <Spinner size={"xl"} color="red"/>
              <Text><b>Loading...</b></Text>
            </VStack>
          </Center>
        }
        {!isLoading &&
          <VStack alignItems='start' width='100%'>
              <BlogItem postItem={postItem} isCommentWriterOpen={isCommentWriterOpen} setIsCommentWriterOpen={setIsCommentWriterOpen} width={width} isAuthed={isAuthed}/>
              
              {renderCommentWriter()}
              <CommentSection postId={postId} commentItems={postItem.comments} width={width} isAuthed={isAuthed}/>
              
          </VStack>
        }
      </>
    );
};

interface PostItemProps {
  postItem: PostItem
  isCommentWriterOpen: boolean,
  setIsCommentWriterOpen: React.Dispatch<React.SetStateAction<boolean>>
  width: number
  isAuthed: boolean
}

const BlogItem = ({postItem, isCommentWriterOpen, setIsCommentWriterOpen, width, isAuthed}: PostItemProps) => {
  const cookies = new Cookies(null, { path: '/' });
  
  const TEXT_PADDING = "10px"
  const [isPostEditorOpen, setIsPostEditorOpen] = useState(useLocation().state.postEditor ? useLocation().state.postEditor : false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)

  const navigate = useNavigate(); 
  const navigateHome = () =>{ 
    const path = `/`; 
    navigate(path);
  }

  const editClicked = () => {
    setIsPostEditorOpen(!isPostEditorOpen)
    return
  }

  const deleteClicked = () => {
    setShowDeleteConfirmation(!showDeleteConfirmation)
    return
  }

  const pinClicked = () => {
    submitPinPost()
    return
  }

  const commentClicked = () => {
    setIsCommentWriterOpen(!isCommentWriterOpen)
    return
  }

  const submitUpdatePost = (title: string, value: string) => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }
    
    fetch(location.protocol + '//' + location.host + '/update/post', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postItem.postId,
        "title": title,
        "contents": value,
        "token": token
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Post successfully updated!")
        navigate(".", {
          replace: true,
          state: {
            commentWriter: false,
            postEditor: false,
          }
        });
        window.location.reload();
      } else {
        alert("Failed to update post.")
      }
    })

    setIsPostEditorOpen(!isPostEditorOpen)
  }

  const submitPinPost = () => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }

    fetch(location.protocol + '//' + location.host + '/pin/post', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postItem.postId,
        "pinned": postItem.pinned,
        "token": token
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Post successfully pinned / unpinned!")
        navigateHome()
      } else {
        alert("Failed to pin post.")
      }
    })
  }

  const submitDeletePost = () => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }
    
    setShowDeleteConfirmation(false)
    fetch(location.protocol + '//' + location.host + '/delete/post', {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postItem.postId,
        "token": token
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Post successfully deleted!")
        navigateHome()
      } else {
        alert("Failed to delete post.")
      }
    })
  }

  const renderPostEditor = () => {
    if (isPostEditorOpen && postItem.title) {
      return (
        <QuillEditor onSubmit={submitUpdatePost} topText={"Update Post"} topTextSize="medium" hasTitleField={true} p='4' m='0' titleContents={postItem.title} contents={postItem.contents} width={width}/>
      )
    }

    return null
  }

  return (
    <>
      <Box
        minW='100%'
        maxW='100%'
        borderWidth="1px"
        borderColor={useColorModeValue('black', 'gray.900')}>
          <VStack
            alignItems={'start'}
            minW='100%'
            maxW='100%'
            p={String(Math.ceil((2.0/650 * width * 2)))}
            // p="10"
            // paddingBottom='6'
            // borderBottomWidth="1px"
            // borderBottomColor={useColorModeValue('black', 'gray.900')}
          >
              {!isPostEditorOpen && 
              <>
                <HStack 
                    minW='100%'
                    maxW='100%'>
                    <Box 
                        minW='80%'
                        maxW='80%'>
                        <Text p={TEXT_PADDING} fontSize={calculateTitleSize(postItem.title.length, width)}>
                          <b>{postItem.title}</b>
                        </Text>
                        <Text pl={TEXT_PADDING} pr={TEXT_PADDING} pb={TEXT_PADDING} fontSize={calculateSize(18, width)}>
                          Posted {moment(new Date(Number(postItem.timestamp) * 1000)).format("MMMM Do YYYY, hh:mm:ss")} : {postItem.postId}
                        </Text>
                    </Box>
                    <VStack minW="20%" maxW="20%" alignItems="end">
                        {isAuthed && 
                          <HStack>
                              <Link onClick={() => editClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                                  Edit
                              </Link>
                              <Link onClick={() => deleteClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                                  Delete
                              </Link>
                              <Link onClick={() => pinClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                                  Pin
                              </Link>
                          </HStack>
                        }
                    </VStack>
                </HStack>
                <Box
                  sx={{
                    "*": { all: "revert" },
                  }}
                  fontSize={calculateSize(18, width)}
                >
                   <div dangerouslySetInnerHTML={{__html: postItem.contents}} />
                </Box>
              </>
              }
              {isPostEditorOpen && 
                    <VStack minW="100%" maxW="100%" alignItems="end">
                        {isAuthed && 
                          <HStack>
                              <Link onClick={() => editClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                                  Edit
                              </Link>
                              <Link onClick={() => deleteClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                                  Delete
                              </Link>
                              <Link onClick={() => pinClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                                  Pin
                              </Link>
                          </HStack>
                        }
                        {renderPostEditor()}
                    </VStack>
              }
              <VStack minW="100%" maxW="100%" alignItems="end">
                  <HStack>
                      <Link onClick={() => commentClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                          Comment
                      </Link>
                  </HStack>
              </VStack>
          </VStack>
      </Box>
      <>
        {showDeleteConfirmation &&
          <Box style={{
            "position": "fixed",
            "top": "50%",
            "left": "50%",
            "transform": "translate(-50%, -50%)",
            "backgroundColor": "whitesmoke",
            "padding": "20px",
            "borderRadius": "5px",
            "boxShadow": "0 2px 5px rgba(0, 0, 0, 0.2)",
            "width": "500px", "height": "125px"}}>
              <VStack>
                <Center>
                  <VStack>
                    <Text fontSize={calculateSize(18, width)}>
                      <b>Are you sure you want to delete this post?</b>
                    </Text>
                    <Text fontSize={calculateSize(18, width)}>
                      <b>Post ID: {postItem.postId}</b>
                    </Text>
                  </VStack>
                </Center>
                <HStack>
                  <Button
                        rightIcon={<ArrowForwardIcon />}
                        variant="solid"
                        color='white'
                        backgroundColor='red'
                        size='sm'
                        onClick={() => setShowDeleteConfirmation(!showDeleteConfirmation)}
                        fontSize={calculateSize(18, width)}
                    >
                    Cancel
                  </Button>
                  <Button
                        rightIcon={<ArrowForwardIcon />}
                        variant="solid"
                        color='white'
                        backgroundColor='green'
                        size='sm'
                        onClick={() => submitDeletePost()}
                        fontSize={calculateSize(18, width)}
                    >
                    Delete
                  </Button>
                </HStack>
              </VStack>
          </Box>
        }
      </>
    </>
  );
};

interface CommentSectionProps {
  postId: string
  commentItems: {[key: string]: CommentItem}
  width: number
  isAuthed: boolean
}

const CommentSection = ({postId, commentItems, width, isAuthed}: CommentSectionProps) => {

  // API HOOKUP REQUIRED
  // const pullCommentSectionData = () => {
  //   alert(`'pullCommentSectionData' NOT YET IMPLEMENTED (postId = ${postId})`)
  // }

  // useEffect(() => {
  //   pullCommentSectionData();
  // }, []);

  return (
    <VStack
      alignItems={'start'}
      minW='100%'
      maxW='100%'
      p={String(Math.ceil((2.0/650 * width * 2)))}
      borderWidth='0px'
      borderColor='red'>
        {commentItems != null && Object.values(commentItems).length != 0 && (Object.values(commentItems)
            .sort((a: CommentItem, b: CommentItem) => Number(a.timestamp) > Number(b.timestamp) ? 1 : -1)  // newer items go at the bottom
            .sort((a: CommentItem, b: CommentItem) => Number(a.pinned) > Number(b.pinned) ? -1 : 1))
            .map((commentItem: CommentItem) => 
          <CommentItem postId={postId} commentItem={commentItem} width={width} isAuthed={isAuthed} key={commentItem.commentId}/>
        )}
    </VStack>
  )
}

interface CommentItemProps {
  postId: string
  commentItem: CommentItem
  width: number
  isAuthed: boolean
}

const CommentItem = ({postId, commentItem, width, isAuthed}: CommentItemProps) => {
  const cookies = new Cookies(null, { path: '/' });

  const TEXT_PADDING = "4px"
  const ITEM_HEIGHT = "20vh"
  const ITEM_HEIGHT_NUM = 20
  const MAX_CHARACTERS = 280
  
  const [isRepliesOpen, setIsRepliesOpen] = useState(false);
  const [isReplyWriterOpen, setIsReplyWriterOpen] = useState(false);
  const [isCommentEditorOpen, setIsCommentEditorOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)

  const navigate = useNavigate(); 

  const renderCommentEditor = () => {
    if (isCommentEditorOpen) {
      return (
        <QuillEditor onSubmit={submitUpdateComment} topText={"Update Comment"} topTextSize="small" hasTitleField={false} p='4' m='0' contents={commentItem.contents} width={width}/>
      )
    }

    return null
  }

  const renderReplyWriter = () => {
    if (isReplyWriterOpen) {
      return (
        <QuillEditor onSubmit={submitReply} topText={"New Reply"} topTextSize="small" hasTitleField={false} p='4' m='0' width={width}/>
      )
    }

    return null
  }

  useEffect(() => {
    
  }, [isRepliesOpen]);

  const submitUpdateComment = (title: string, value: string) => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }

    fetch(location.protocol + '//' + location.host + '/update/comment', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postId,
        "commentId": commentItem.commentId,
        "contents": value,
        "token": token
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Comment successfully updated!")
        navigate(".", {
          replace: true,
          state: {
            commentWriter: false,
            postEditor: false,
          }
        });
        window.location.reload();
      } else {
        alert("Failed to update comment.")
      }
    })

    setIsCommentEditorOpen(!isCommentEditorOpen)
  }

  const submitPinComment = () => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }
    
    fetch(location.protocol + '//' + location.host + '/pin/comment', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postId,
        "commentId": commentItem.commentId,
        "pinned": !commentItem.pinned,
        "token": token
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Comment successfully pinned / unpinned!")
        navigate(".", {
          replace: true,
          state: {
            commentWriter: false,
            postEditor: false,
          }
        });
        window.location.reload();
      } else {
        alert("Failed to pin comment.")
      }
    })
  }

  const submitDeleteComment = () => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }

    setShowDeleteConfirmation(false)
    fetch(location.protocol + '//' + location.host + '/delete/comment', {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postId,
        "commentId": commentItem.commentId,
        "token": token
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Comment successfully deleted!")
        navigate(".", {
          replace: true,
          state: {
            commentWriter: false,
            postEditor: false,
          }
        });
        window.location.reload();
      } else {
        alert("Failed to delete comment.")
      }
    })
  }

  const submitReply = (_: string, value: string) => {
    fetch(location.protocol + '//' + location.host + '/create/reply', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postId,
        "commentId": commentItem.commentId,
        "contents": value,
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Reply successfully submitted!")
        navigate(".", {
          replace: true,
          state: {
            commentWriter: false,
            postEditor: false,
          }
        });
        window.location.reload();
      } else {
        alert("Failed to submit reply.")
      }
    })
      setIsReplyWriterOpen(!isReplyWriterOpen)
  }

  // API HOOKUP REQUIRED
  const editClicked = () => {
    // alert("'editClicked' NOT YET IMPLEMENTED")
    setIsCommentEditorOpen(!isCommentEditorOpen)
    return
  }

  // API HOOKUP REQUIRED (admin only)
  const deleteClicked = () => {
    // alert("'deleteClicked' NOT YET IMPLEMENTED")
    setShowDeleteConfirmation(!showDeleteConfirmation)
    // submitDeleteComment()
    return
  }

  // API HOOKUP REQUIRED (admin only)
  const pinClicked = () => {
    // alert("'pinClicked' NOT YET IMPLEMENTED!")
    submitPinComment()
    return
  }

  // API HOOKUP REQUIRED
  const repliesDropdownClicked = () => {
    // alert("'repliesDropdownClicked' NOT YET IMPLEMENTED")
    setIsRepliesOpen(!isRepliesOpen)
  }

  // API HOOKUP REQUIRED
  const replyClicked = () => {
    // alert("'replyClicked' NOT YET IMPLEMENTED")
    setIsReplyWriterOpen(!isReplyWriterOpen)
    return
  }

  const renderReplies = () => {
    if (isRepliesOpen) {
      return (
        <ReplySection postId={postId} commentId={commentItem.commentId} replyItems={commentItem.replies} width={width} isAuthed={isAuthed}/>
      )
    }

    return null
  }

  return (
    <>
      <Box
        minW='100%'
        maxW='100%'
        minH={ITEM_HEIGHT}
        // maxH={ITEM_HEIGHT}
        borderWidth="1px"
        borderColor={useColorModeValue('black', 'gray.900')}
        backgroundColor={commentItem.pinned ? "lightyellow" : "white"}
        style={{textOverflow: 'ellipsis'}}>
          <VStack
            alignItems={'start'}
            minW='100%'
            maxW='100%'
            minH={ITEM_HEIGHT}
            // maxH={ITEM_HEIGHT}
            p={String(Math.ceil((2.0/650 * width * 2)))}
          >
            <HStack 
              minW='100%'
              maxW='100%'
              minH={ITEM_HEIGHT_NUM * 0.3}
              // maxH={ITEM_HEIGHT_NUM * 0.3}
              >
              <VStack
                minW="80%"
                maxW="80%"
                alignItems="start">
                <Text style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                  {commentItem.pinned ? "(PINNED) | " : ""} {">>"} Posted {moment(new Date(Number(commentItem.timestamp) * 1000)).format("MMMM Do YYYY, hh:mm:ss")} : {commentItem.commentId} 
                </Text>
              </VStack>
              <VStack
                minW="20%"
                maxW="20%"
                alignItems="end">
                {isAuthed && 
                  <HStack>
                    <Link onClick={() => editClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                      Edit
                    </Link>
                    <Link onClick={() => deleteClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                      Delete
                    </Link>
                    <Link onClick={() => pinClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                      Pin
                    </Link>
                  </HStack>
                }
              </VStack>
            </HStack>
            {isCommentEditorOpen &&
              <> 
                {renderCommentEditor()}
              </>
            }
            {!isCommentEditorOpen && 
              <Text
                p={TEXT_PADDING}
                fontSize={calculateSize(18, width)}>
                <div dangerouslySetInnerHTML={{__html: commentItem.contents.substring(0, MAX_CHARACTERS)}} />
                {/* &#09;{commentItem.contents.substring(0, MAX_CHARACTERS)} */}
              </Text>
            }
            <VStack
              minW="100%"
              maxW="100%"
              alignItems="end"
              minH={ITEM_HEIGHT_NUM * 0.2}
              // maxH={ITEM_HEIGHT_NUM * 0.2}
              >
              <HStack>
                <Link onClick={() => replyClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                Reply
                  {/* Replies ({replies.length}) {eval("if (isRepliesOpen) {return('v')} else {return('^')}")} */}
                </Link>
                <Link onClick={() => repliesDropdownClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                Replies ({Object.values(commentItem.replies).length})
                  {/* Replies ({replies.length}) {eval("if (isRepliesOpen) {return('v')} else {return('^')}")} */}
                </Link>
              </HStack>
              {renderReplyWriter()}
            </VStack>
            {renderReplies()}
          </VStack>
      </Box>
      <>
        {showDeleteConfirmation &&
          <Box style={{
            "position": "fixed",
            "top": "50%",
            "left": "50%",
            "transform": "translate(-50%, -50%)",
            "backgroundColor": "whitesmoke",
            "padding": "20px",
            "borderRadius": "5px",
            "boxShadow": "0 2px 5px rgba(0, 0, 0, 0.2)",
            "width": "500px", "height": "125px"}}>
              <VStack>
                <Center>
                <VStack>
                  <Text fontSize={calculateSize(18, width)}>
                    <b>Are you sure you want to delete this comment?</b>
                  </Text>
                  <Text fontSize={calculateSize(18, width)}>
                    <b>Comment ID: {commentItem.commentId}</b>
                  </Text>
                </VStack>
                </Center>
                <HStack>
                  <Button
                        rightIcon={<ArrowForwardIcon />}
                        variant="solid"
                        color='white'
                        backgroundColor='red'
                        size='sm'
                        onClick={() => setShowDeleteConfirmation(!showDeleteConfirmation)}
                        fontSize={calculateSize(18, width)}
                    >
                    Cancel
                  </Button>
                  <Button
                        rightIcon={<ArrowForwardIcon />}
                        variant="solid"
                        color='white'
                        backgroundColor='green'
                        size='sm'
                        onClick={() => submitDeleteComment()}
                        fontSize={calculateSize(18, width)}
                    >
                    Delete
                  </Button>
                </HStack>
              </VStack>
          </Box>
        }
      </>
    </>
  );
};
  

interface ReplySectionProps {
  postId: string
  commentId: string
  replyItems: {[key: string]: ReplyItem}
  width: number
  isAuthed: boolean
}

const ReplySection = ({postId, commentId, replyItems, width, isAuthed}: ReplySectionProps) => {;

  return (
    <VStack
      alignItems={'start'}
      minW='100%'
      maxW='100%'
      p={String(Math.ceil((2.0/650 * width * 2)))}
      borderWidth='0px'
      borderColor='red'>
        {replyItems != null && Object.values(replyItems).length != 0 && (Object.values(replyItems)
            .sort((a: ReplyItem, b: ReplyItem) => Number(a.timestamp) > Number(b.timestamp) ? 1 : -1))
            .map((replyItem: ReplyItem) =>
          <ReplyItem postId={postId} commentId={commentId} replyItem={replyItem} width={width} isAuthed={isAuthed} key={replyItem.replyId}/>
        )}
        {/* <CommentItem commentId="1111111111" replies={["this is reply 1"]} contents="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!"/>
        <CommentItem commentId="1111111111" replies={["this is reply 1"]} contents="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!"/>
        <CommentItem commentId="1111111111" replies={["this is reply 1", "this is reply 2"]} contents="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.!"/> */}

    </VStack>
  )
}

interface ReplyItemProp {
  postId: string
  commentId: string
  replyItem: ReplyItem
  width: number
  isAuthed: boolean
}

const ReplyItem = ({postId, commentId, replyItem, width, isAuthed}: ReplyItemProp) => {
  const cookies = new Cookies(null, { path: '/' });
  
  const TEXT_PADDING = "4px"
  const ITEM_HEIGHT = "10vh"
  const ITEM_HEIGHT_NUM = 10
  const MAX_CHARACTERS = 280

  const [isReplyEditorOpen, setIsReplyEditorOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)

  const navigate = useNavigate(); 

  const submitUpdateReply = (title: string, value: string) => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }

    fetch(location.protocol + '//' + location.host + '/update/reply', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postId,
        "commentId": commentId,
        "replyId": replyItem.replyId,
        "contents": value,
        "token": token
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Reply successfully updated!")
        navigate(".", {
          replace: true,
          state: {
            commentWriter: false,
            postEditor: false,
          }
        });
        window.location.reload();
      } else {
        alert("Failed to update reply.")
      }
    })

    setIsReplyEditorOpen(!isReplyEditorOpen)
  }

  const submitDeleteReply = () => {
    let token = cookies.get("token")
    if (token === undefined) {
      token = ""
    }

    setShowDeleteConfirmation(false)
    fetch(location.protocol + '//' + location.host + '/delete/reply', {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "postId": postId,
        "commentId": commentId,
        "replyId": replyItem.replyId,
        "token": token
      })
    })
    .then((res) => {
      if (res.status === 200) {
        alert("Reply successfully deleted!")
        navigate(".", {
          replace: true,
          state: {
            commentWriter: false,
            postEditor: false,
          }
        });
        window.location.reload();
      } else {
        alert("Failed to delete reply.")
      }
    })
  }

  const editClicked = () => {
    setIsReplyEditorOpen(!isReplyEditorOpen)
    return
  }

  const deleteClicked = () => {
    setShowDeleteConfirmation(!showDeleteConfirmation)
    return
  }

  const renderReplyEditor = () => {
    if (isReplyEditorOpen) {
      return (
        <QuillEditor onSubmit={submitUpdateReply} topText={"Update Reply"} topTextSize="small" hasTitleField={false} p='4' m='0' contents={replyItem.contents} width={width}/>
      )
    }

    return null
  }

  return (
    <>
      <Box
        minW='100%'
        maxW='100%'
        minH={ITEM_HEIGHT}
        borderWidth="1px"
        borderColor={useColorModeValue('black', 'gray.900')}
        style={{textOverflow: 'ellipsis'}}>
          <VStack
            alignItems={'start'}
            minW='100%'
            maxW='100%'
            minH={ITEM_HEIGHT}
            p={String(Math.ceil((2.0/650 * width * 2)))}
          >
            <HStack 
              minW='100%'
              maxW='100%'
              minH={ITEM_HEIGHT_NUM * 0.3}
              // maxH={ITEM_HEIGHT_NUM * 0.3}
              >
              <VStack
                minW="80%"
                maxW="80%"
                alignItems="start">
                <Text style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                {">>"} Posted {moment(new Date(Number(replyItem.timestamp) * 1000)).format("MMMM Do YYYY, hh:mm:ss")} : {replyItem.replyId} 
                </Text>
              </VStack>
              <VStack
                minW="20%"
                maxW="20%"
                alignItems="end">
                {isAuthed && 
                  <HStack>
                    <Link onClick={() => editClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                      Edit
                    </Link>
                    <Link onClick={() => deleteClicked()} style={{"fontWeight": "bold"}} fontSize={calculateSize(18, width)}>
                      Delete
                    </Link>
                  </HStack>
                }
              </VStack>
            </HStack>
            {isReplyEditorOpen &&
              <>
                {renderReplyEditor()}
              </>
            }
            {!isReplyEditorOpen &&
              <Text
                p={TEXT_PADDING}
                fontSize={calculateSize(18, width)}>
                <div dangerouslySetInnerHTML={{__html: replyItem.contents.substring(0, MAX_CHARACTERS)}} />
                {/* &#09;{replyItem.contents.substring(0, MAX_CHARACTERS)} */}
              </Text>
            }
          </VStack>
      </Box>
      <>
        {showDeleteConfirmation &&
          <Box style={{
            "position": "fixed",
            "top": "50%",
            "left": "50%",
            "transform": "translate(-50%, -50%)",
            "backgroundColor": "whitesmoke",
            "padding": "20px",
            "borderRadius": "5px",
            "boxShadow": "0 2px 5px rgba(0, 0, 0, 0.2)",
            "width": "500px", "height": "125px"}}>
              <VStack>
                <Center>
                <VStack>
                  <Text fontSize={calculateSize(18, width)}>
                    <b>Are you sure you want to delete this reply?</b>
                  </Text>
                  <Text fontSize={calculateSize(18, width)}>
                    <b>Reply ID: {replyItem.replyId}</b>
                  </Text>
                </VStack>
                </Center>
                <HStack>
                  <Button
                        rightIcon={<ArrowForwardIcon />}
                        variant="solid"
                        color='white'
                        backgroundColor='red'
                        size='sm'
                        onClick={() => setShowDeleteConfirmation(!showDeleteConfirmation)}
                        fontSize={calculateSize(18, width)}
                    >
                    Cancel
                  </Button>
                  <Button
                        rightIcon={<ArrowForwardIcon />}
                        variant="solid"
                        color='white'
                        backgroundColor='green'
                        size='sm'
                        onClick={() => submitDeleteReply()}
                        fontSize={calculateSize(18, width)}
                    >
                    Delete
                  </Button>
                </HStack>
              </VStack>
          </Box>
        }
      </>
    </>
    // <Text>
    //   {replyItem.contents}
    // </Text>
  )
}

export default Post;